
import axios from 'axios';

const instance = axios.create({ 
    baseURL: process.env.REACT_APP_URL_BASE_LISTA_ACUERDOS,
    headers: { "X-Api-Key" : process.env.REACT_APP_API_KEY_LISTA_ACUERDOS }
});

const request = {
    get: (url: string) => instance.get(url),
    post: (url: string, body: any) => instance.post(url, body),
    put: (url: string, body: any) => instance.put(url, body),
    delete: (url: string) => instance.delete(url)
}

export default request;